import {
    CompetitionAnalyzerCheckElementsProvider,
    CompetitionAnalyzerPriceByNightTablesProvider,
    CompetitionAnalyzerDetailsDrawerProvider,
    CompetitionAnalyzerCalendarProvider,
    CompetitionAnalyzerWeekdayFilterProvider,
    CompetitionAnalyzerPivotProvider,
} from "./@contexts"
import React from "react"

// NOTA: CompetitionAnalyzerVsPreviousPriceProvider se monta a NIVEL DE Analyzer2.1/index.jsx
// (envuelve Cards + Tables). No aquí, porque las Cards viven fuera del subárbol de Tables
// y también consumen previousData.

export default function CompetitionAnalyzerTablesProviders({ children }) {

    return <CompetitionAnalyzerCheckElementsProvider>
        <CompetitionAnalyzerWeekdayFilterProvider>
            <CompetitionAnalyzerDetailsDrawerProvider>
                <CompetitionAnalyzerPriceByNightTablesProvider>
                    <CompetitionAnalyzerCalendarProvider>
                        <CompetitionAnalyzerPivotProvider>
                            {children}
                        </CompetitionAnalyzerPivotProvider>
                    </CompetitionAnalyzerCalendarProvider>
                </CompetitionAnalyzerPriceByNightTablesProvider>
            </CompetitionAnalyzerDetailsDrawerProvider>
        </CompetitionAnalyzerWeekdayFilterProvider>
    </CompetitionAnalyzerCheckElementsProvider>
}

export {
    CompetitionAnalyzerCompetitionDailyTableProvider,
    CompetitionAnalyzerRankingTableProvider,
    CompetitionAnalyzerPriceByNightTablesContext,
    CompetitionAnalyzerCalendarContext,
    CompetitionAnalyzerCheckElementsContext,
    CompetitionAnalyzerDetailsDrawerContext,
    CompetitionAnalyzerDailyTableContext,
    CompetitionAnalyzerRankingTableContext,
    CompetitionAnalyzerWeekdayFilterContext,
    CompetitionAnalyzerPriceComparisonContext,
    CompetitionAnalyzerPriceComparisonProvider,
    CompetitionAnalyzerPivotContext,
    CompetitionAnalyzerPivotProvider,
    CompetitionAnalyzerVsPreviousPriceContext,
    CompetitionAnalyzerVsPreviousPriceProvider,
    CompetitionAnalyzerGroupComparisonContext,
    CompetitionAnalyzerGroupComparisonProvider,
} from "./@contexts"
